import {
  FinleyValleyBankResponseTapeRow,
  FinleyLoanParty,
} from '@finley-technologies/valley-bank-utils';

// @vb-deriv - this is a dup. remove / consolidate
export const getCustomerFromReceivable = (
  receivables: FinleyValleyBankResponseTapeRow[],
  loanParties: FinleyLoanParty[],
): FinleyLoanParty | null => {
  const cifnum = receivables[0]?.cif_num;
  if (!cifnum) return null;
  return loanParties.find((party) => party.cif_num === cifnum) || null;
};
